// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2O8jl","name":"ConsentHeader_name__1ImMN","birthday":"ConsentHeader_birthday__3Oany","skeleton":"ConsentHeader_skeleton__2Jsai"};